import { Component, h } from 'preact';
import CSSModules from 'react-css-modules';
import ClassNames from 'classnames';
import styles from '../../css/app.css';
import { Link } from 'preact-router/match';
import events from '../../utils-and-data/events.js';
import TweenLite from 'gsap/TweenLite';
import CSSPlugin from 'gsap/CSSPlugin';

class EndPage extends Component {
  constructor(props) {
    super(props);
    this.initialised = false;
    this.startTimer = null;
  }

  componentDidUpdate(prevProps,prevState) {
    if (prevProps.order !== this.props.order) this.initOrDestroy();
  }

  componentDidMount() {
    this.initOrDestroy(this.props);
  }

  componentWillUnmount() {
    this.destroyGhost();
  }

  initOrDestroy() {
    if (this.props.order === 'curr'
      && this.initialised === false) {

      this.initialised = true;
      this.startTimer = setTimeout(() => this.initGhost(), 5);
    } else {
      this.destroyGhost();
    }
  }

  initGhost() { 
    events.emit('hideHeader');
    TweenLite.to(this.steamRef, 3, {
      opacity: 1,
      onComplete: () => {
        // TweenLite.set(this.steamRef, {
        //   userSelect: 'none',
        //   pointerEvents: 'none'
        // });
        // TweenLite.set(this.textRef, {
        //   userSelect: 'auto',
        //   pointerEvents: 'auto'
        // });
        TweenLite.to(this.textRef, 10, {
          opacity: 1,
          delay: 1.5
        });
      }
    });
    TweenLite.to(this.eapLogoRef, 8, {
      opacity: 1,
      delay: 11,
    });
    this.initialised = true;
  }

  destroyGhost() {
    clearTimeout(this.startTimer);
    if (!this.initialised) return;
    events.emit('showHeader');
    TweenLite.killTweensOf([this.eapLogoRef, this.textRef, this.steamRef]);
    TweenLite.set([this.eapLogoRef, this.textRef, this.steamRef], { 
      clearProps: 'all' 
    });
    this.initialised = false;
  }

  storeRef(type, el) {
    if (el !== null) this[type] = el;
  }

  render() {
    return (
      <div styleName='end-page' 
        className={ClassNames(this.props.order)}>

        <i styleName='loading-steam' 
          ref={t => this.storeRef('steamRef', t)} />

        <div className='inner'
          ref={t => this.storeRef('textRef', t)}>

          <p>Now go somewhere else</p>
          <Link href='/?returning=true'>
            I'm ready to<br />Breathe again
          </Link>
        </div>

        <img className='eap-logo' 
          ref={l => this.storeRef('eapLogoRef', l)}
          src={require('../../img/eap-icon.png')} 
          alt='EAP Logo' />
      </div>
    )
  }
}

// Apply 'react-css-modules' to this react component:
export default CSSModules(EndPage, styles);
// export default EndingPage;



// WEBPACK FOOTER //
// ./app/frontend/components/panels/ghost-end-page.jsx